<template>
<div>
    <smallbutton :toplabel="titleLabel_short" @click="startAdd()" v-if="showButton" :buttonclass="buttonclass" :disabled="disabled"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">{{ titleLabel }}</label>
                <br/>
                
                <br>
                <div class="entry"  >
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="">Type</label>
                        </div>
                        <div class="entryTextDiv">
                        <select name="" id="" class='entrySelect'  v-model="currentType.typeId" :required="trueParam" @change="selecttype">
                            <option v-for="t in imageTypeList" :key="t.id" :value="t.id" >
                                {{t.name}}
                            </option>
                        </select>
                        </div>
                    </div>
        
                  <!-- image -->
                <div class="showProductImage">
                    <br>
                    <br>
                    <div class="personPhoto" v-if="currentType.fileName!=null">
                        <img :src="getProductImage"  width="100" class="" >
                    </div>
                    <smallbutton toplabel="Add Image" @Click="addfile" :disabled="currentType.typeId==0" v-if="currentType.fileName==null"/>
                    <smallbutton toplabel="Replace Image" @Click="addfile" :disabled="currentType.typeId==0" v-if="currentType.fileName!=null"/>
                    <smallbutton toplabel="Edit Image" v-if="currentType.fileName!=null" @click="editImage()" />
                    <imagealldoc ref="imgdoc"  fileAccept="*.*"  :allowFileSelect="trueParam" :allowCapture="falseParam" @saveimg="saveimg_document"  :showImage='falseParam' />
                    <imageeditor ref="imgedit" :img="selectedImageURL" @save="saveimg_document"/>
                </div>

                <div>
                    <label class="pleasewait" v-if="pleaseWait">Please Wait...</label>
                </div>
                
                <!-- <smallbutton  @click="save()" toplabel="Save" buttonclass="button buttonsave"/> -->
                <smallbutton  @click="close()" toplabel="Close" buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{message}}</label>
                </div>
                 <confirm ref="confirmUpdate" body="An image of this type exists.  Do you want to update or replace it?" title="Image Exists" @yes="changetoupdate()"  @no="currentType.typeId=0" :showButton="falseParam"/>
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import format from '../../format.js'
import datamethods from '../../services/datamethods.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
 import imagealldoc from '../controls/ImageAll.vue'
 import imageeditor from '../controls/ImageEditor.vue'
 import confirm from '../actions/confirm.vue'
export default {
    name:'updateimage',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        imagealldoc,
        imageeditor,
        confirm
    },
    props:{
        inType:{
            type:Object,
        },
        isAdd:{
            type:Boolean,
            default:false
        },
        typeName:{
            type:String,
            required:true
        },
        showButton:{
            type:Boolean,
            default:false
        },
        buttonclass:{
          type:String,
          default:"button buttonprimary"
        },
        disabled:{
            type:Boolean,
            default:false
        },
        productId:{
            type:Number,

        },
        productImages:{
            type:Array
        }
        
    },
    mixins:[format,datamethods],
    data(){
        return{
            pleaseWait:false,
            imageTypeList:[],
            currentType:{
                id:0,
                name:null,
                isActive:false
            },
            trueParam:true,
            falseParam:false,
            message:null,
            selectedImageURL:null,
            existingImage:null
        }
    },
    computed:{
        
        titleLabel(){
            if(this.currentType.id==0){return "Add " + this.typeName}
            else{ return "Update " + this.currentType.typeName  }
        },
        titleLabel_short(){
            if(this.isAdd){return "Add"}
            else{ return "Update"  }
        },
        getProductImage(){
       
                if(this.currentType.fileName==null){return null}
                    var imgBasePath =  window.VUE_CONFIG_API + 'personimage/'

                var fn = this.currentType.fileName
                var splitfn=fn
                const lastDot = fn.lastIndexOf('.');
                if (lastDot > 0) {
                splitfn= fn.slice(0, lastDot) + '/' + fn.slice(lastDot + 1);
                }
                this.selectedImageURL=imgBasePath + splitfn
                    return imgBasePath + splitfn
        },
    },
    mounted(){
        
    },
    methods:{
        selecttype(){
            //if we already have one of these, ask if they want to replace it...if its a limit to one guy
            var mythis=this
            this.existingImage=null
            var selType = this.currentType.typeId
            
            //if we allow multiples, just return...no need to check
            if(this.selectedTypeAllowsMultiples()){return}

            this.productImages.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let t=arr[index]
                        if(t.typeId== selType){
                            mythis.existingImage=t
                        }
                    } 
            if(this.existingImage !=null){
                this.$refs.confirmUpdate.Show()
            }
        },
        selectedTypeAllowsMultiples(){
            var allowmult=false
            var selType = this.currentType.typeId
            
            this.imageTypeList.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let t=arr[index]
                        if(t.id== selType){
                            allowmult=t.allowMultipleImages
                        }
                    } 
            console.log('allow mult ' + allowmult)
            return allowmult
        },
        changetoupdate(){
       
            this.currentType=this.existingImage
        },
        addfile(){
            this.$refs.imgdoc.openModal() 
        },
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        
        editImage(){
            this.$nextTick(()=>{
                this.$refs.imgedit.openModal()
            })
        },
        startAdd(){
            this.message=null
            this.getImageTypes()
           if(this.isAdd){
                this.currentType={
                    id:0,
                    name:null,
                    isActive:false,
                    typeId:0,
                    productId:this.productId
                }
            }else{
                this.currentType = JSON.parse(JSON.stringify(this.inType)) 
            }
            

            this.$refs.mymodal.openModal()
        },
        async save(){
           console.log('refresh from updateimage')
           this.$emit('refresh')
           this.$refs.mymodal.closeModal()
        },
        close(){
            console.log('refresh from updateimage')
           this.$emit('refresh')
            this.$refs.mymodal.closeModal()
        },
        saveimg_document(file,url,typeId){
                    this.storeDocument("doc", file, file.name,typeId)
        },
         saveedits(file, url){
            this.selectedImageURL=url
            this.storeDocument(file.name, file, file.name)
         },
        async storeDocument(filename,file, name,typeId){
            var pId=this.productId
            var pImageTypeId=this.currentType.typeId
            var postParams = new FormData();

            postParams.append(filename,file,name);
            postParams.append('productId',pId);
            postParams.append('productImageTypeId',pImageTypeId);
            postParams.append('productImageId', this.currentType.id)

            this.pleaseWait=true
            var response = await this.callAPI(postParams,'saveproductimagewithtype')
            //handle response
            if(response.Successful){
                //this.RefreshCurrent() 
                this.currentType.fileName= response.StringResponse //"p_" + pId + "_" + pImageTypeId + ".jpg"
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false  
        },  
       async getImageTypes(){
            
            console.log('getimagetypes')
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'productimagetypes')

            if(response.Successful){
                this.imageTypeList=response.ProductImageTypeList
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        }
       
        
    }
}
</script>

<style>

</style>





























